import { Component, EventEmitter, Output } from '@angular/core'
import { CustomTableService } from '../../service/custom-table.service'
import { DefaultRowComponent } from '../default-row/default-row.component'

@Component({
    selector: 'app-dispenser-agreement-product-row',
    templateUrl: './dispenser-agreement-product-row.component.html',
    styleUrls: ['./dispenser-agreement-product-row.component.scss'],
    standalone: false
})
export class DispenserAgreementProductRowComponent extends DefaultRowComponent {
  @Output() changeEvent: EventEmitter<any> = new EventEmitter()
  public invoiceNumber: number
  public quantity: number

  constructor(private customTableService: CustomTableService) {
    super()
  }

  ngOnInit(): void {}

  public onChange(event: any): void {
    if (event.type == 'invoiceNumber') {
      const id = this.row[this.uid]
      const data = this.customTableService.dataSource[id]

      this.invoiceNumber = event.value
      this.changeEvent.emit({
        row: data,
        dispenserQuantity: this.quantity,
        invoiceNumber: this.invoiceNumber,
        type: 'invoiceNumber'
      })
      return
    }
    this.sendProductDetails(event.target.value)
  }

  sendProductDetails(quantity: number) {
    let product: any
    const id = this.row[this.uid]
    const data = this.customTableService.dataSource[id]

    this.quantity = quantity
    if (this.row.code) {
      product = {
        code: this.row.code,
        quantity: quantity,
        name: this.row.name
      }
    } else {
      product = {
        row: data,
        dispenserQuantity: quantity,
        invoiceNumber: this.invoiceNumber
      }
    }
    this.changeEvent.emit(product)
  }
}
